<template>
    <MainContent :title="title">
        <template v-slot:header>
            <slot name="header"></slot>
        </template>

        <template v-slot:subheader>
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <div class="my-3">
                        <SearchComponent v-model="value.search" :disabled="disabled" />
                    </div>
                </div>
                <slot name="extra-options"></slot>
            </div>
        </template>

        <template v-slot:content>
            <slot name="content"></slot>
            <hr/>
            <div class="row justify-content-between">
                <div class="col-12 col-lg-3">
                    <ElementosPorPaginaComponent v-model="value.per_page"/>
                </div>
                <div class="col-12 col-lg-4">
                    <PaginateComponent :current_page="meta.current_page" :last_page="meta.last_page" v-on:change_page="setPage"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
    import MainContent from "./MainContent";
    import ElementosPorPaginaComponent from "./ElementosPorPaginaComponent";
    import SearchComponent from "./SearchComponent";

    export default {
        props: {
            title: String,
            meta: Object,
            value: Object,
            disabled: { type: Boolean, default: false }
        },
        components: {
            SearchComponent,
            ElementosPorPaginaComponent,
            MainContent,
            PaginateComponent
        },
        watch: {
            "value.page"() { this.$emit('updated'); },
            "value.search"() { this.value.page = 1; this.$emit('updated'); },
            "value.per_page"() { this.value.page = 1; this.$emit('updated'); },
        },
        methods: {
            setPage(page) {
                this.value.page = page;
            },
        }
    }
</script>